/**
 * 
 * Global Elements
 * 
 */

const elements = {
    form: document.querySelector('form[action$="/cart/add"]'),
    id: document.querySelector('.js-variant-id'),
    qty: document.querySelector('.js-input-qty'),
}

const redirection = {
    cartUrl: "/cart",
    wholesaleUrl: "/pros"
}

// ATC Function
const addToCart = (form, redirectionUrl) => {
    const freeProduct = form.querySelector('.js-free-product')
    const button = form.querySelector('.js-sh-submit-btn')

    let btnText = button.value

    button.disabled = true
    button.value = "Adding to cart ..."
    

    let formData = {
        'items': [
            {
                'id': +elements.id.value,
                'quantity': +elements.qty.value
            }
        ]
    };

    if (freeProduct) {
        formData.items.push({
            'id': +freeProduct.value,
            'quantity': 1
        })
    }


    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Redirect to cart page
        window.location.href = redirectionUrl
        
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        button.disabled = false
        button.value = btnText
      })
}


// Ensure the script runs only after the page is fully loaded
document.addEventListener("DOMContentLoaded", function () {
    // Get references to the Yes and No radio buttons
    let wholesaleYes = document.querySelector('.sh-js-offer-agree');
    let wholesaleNo = document.querySelector('.sh-js-offer-disagree');

    // Get reference to the Add to Cart button
    let addToCartButton = document.querySelector(".sh-js-btn-offer");

       // Always clear radio button selections when returning to the page
       sessionStorage.removeItem("wholesaleSelected");

        // Delay unchecking to allow the browser to finish restoring inputs
        // Ensures override of browser autofill
        setTimeout(() => {
            if (wholesaleYes) wholesaleYes.checked = false;
            if (wholesaleNo) wholesaleNo.checked = false;
        }, 50); 
  

    // Check if the Yes button exists before adding event listener
    if (wholesaleYes) {
        wholesaleYes.addEventListener("change", function () {
            // Show hidden text
            const hiddenText = document.querySelector('.js-sh-hidden-text')
            
            if (hiddenText) { // Check if the element exists before trying to modify it
            hiddenText.removeAttribute('hidden');
            } else {
            console.error("Element with class 'js-sh-hidden-text' not found.");
            }
            
            // Store selection
            sessionStorage.setItem("wholesaleSelected", "true"); 

            // ATC to cart
            addToCart(elements.form, redirection.wholesaleUrl);
        });
    }

    // Check if the No button exists before adding event listener
    if (wholesaleNo) {
        wholesaleNo.addEventListener("change", function () {
            // Enable the Add to Cart button when "No" is selected
            addToCartButton.classList.add("active");
            addToCartButton.removeAttribute("disabled");
        });
    }
});


elements.form.addEventListener('submit', e => {
    e.preventDefault()

    addToCart(elements.form, redirection.cartUrl);
    
})